const popupReducer = (shown = "none", action) => {
    switch(action.type){
        case 'CHANGE_POPUP':
            shown = action.data
            return shown;
        default:
            return shown;
    }
}

export default popupReducer;